import React, { Component, useLayoutEffect, useState } from 'react';
import axios from 'axios';
import * as R from 'ramda';
import HashLoader from 'react-spinners/HashLoader';
import ReporForm from './ReportForm';
import Exporter from './Exporter';
import {
  MODEL_STANDARD,
  getModelName,
  getNoise,
  getVolume,
} from '../Services/ValueTransform';
import {
  M3H,
  LS,
  TOTAL_P,
  STATIC_P,
  NOISE_1m,
  NOISE_3m,
} from '../Services/ValueTransform';
import ExportModal from '../Components/ExportModal';
import PreviewModal from '../Components/PreviewModal';
const Reporter = ({ fans, handleSearch, modelType, loading }) => {
  const [tab, setTab] = useState(1);
  const [show, setShow] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [selectedFan, setSelectedFan] = useState([]);
  const [modelTypeSelect, setModelTypeSelect] = useState(MODEL_STANDARD);
  const [form, setForm] = useState({
    volume: '',
    pressure: '',
    pressureType: STATIC_P,
    volumeType: M3H,
    poles: 4,
    supply: 50,
    noise: NOISE_3m,
  });

  useLayoutEffect(() => {
    if (tab == 2) {
      setTimeout(() => {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
      }, 200);
    }
  }, [tab]);

  const handleForm = (value, id) => {
    form[id] = value;
    setForm({ ...form });
  };

  const handleSelect = (ff) => {
    const fan = { ...ff, configs: { ...form, modelTypeSelect } };
    const isSelected = R.findIndex((item) => {
      return (
        item.id == ff.id &&
        getModelName(ff, fan.configs.modelTypeSelect) ===
          getModelName(item, item.configs.modelTypeSelect)
      );
    }, selectedFan);
    if (isSelected >= 0) {
      setTab(2);
    } else {
      const updated = R.append(fan, selectedFan);
      setSelectedFan(updated);
      setTab(2);
    }
  };

  const handleDeselect = (ff) => {
    const isSelected = R.findIndex((item) => {
      return (
        item.id == ff.id &&
        getModelName(ff, ff.configs.modelTypeSelect) ===
          getModelName(item, item.configs.modelTypeSelect)
      );
    }, selectedFan);
    if (isSelected >= 0) {
      const updated = R.remove(isSelected, 1, selectedFan);
      setSelectedFan(updated);
    }
  };

  const isSelected = (id) => {
    return R.findIndex((fid) => fid == id, selectedFan) >= 0;
  };

  const onSearch = (form) => {
    handleSearch(form);
    setModelTypeSelect(modelType);
  };

  const handlePDF = () => {
    setShow(true);
  };

  const handlePreview = (fan) => {
    setShowPreview(fan);
  };

  return (
    <>
      <ExportModal
        show={show}
        selecteds={selectedFan}
        handleClose={() => {
          setShow(false);
        }}
      />
      <PreviewModal
        fan={showPreview}
        handleClose={() => {
          setShowPreview(false);
        }}
        modelTypeSelect={modelTypeSelect}
      />
      <div style={{ paddingLeft: 10, width: 'calc(100% - 300px)' }}>
        <div class='grid grid-cols-1'>
          <div class='text-center rounded-[5px] py-[30px] px-[30px] bg-custom relative text-white'>
            <div class='bg-[url(../images/wave-mask.png)] absolute inset-0 bg-cover bg-center bg-no-repeat w-full h-full'></div>
            <div
              class='py-5 w-full relative z-10 text-left'
              style={{ display: 'flex' }}
            >
              <div
                className='px-6'
                style={
                  tab == 1
                    ? { borderBottom: 'solid 1px', cursor: 'pointer' }
                    : { cursor: 'pointer' }
                }
                onClick={() => setTab(1)}
              >
                <span class='font-bold'>Airflow</span>
              </div>
              <div
                className='px-6'
                style={
                  tab == 2
                    ? { borderBottom: 'solid 1px', cursor: 'pointer' }
                    : { cursor: 'pointer' }
                }
                onClick={() => setTab(2)}
              >
                <span class='font-bold'>Report</span>
              </div>
            </div>
          </div>
        </div>
        {tab == 1 && (
          <div class='py-6'>
            <ReporForm
              onSearch={onSearch}
              form={form}
              handleForm={handleForm}
            />
            <div
              class='relative overflow-x-auto'
              style={{
                marginTop: 50,
                paddingTop: 10,
                width: '100%',
                paddingLeft: 25,
                borderTop: '1px solid rgb(10 161 149 / var(--tw-bg-opacity))',
                minHeight: 150,
              }}
            >
              {loading && (
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: 50,
                  }}
                >
                  <HashLoader
                    color={'#36d7b7'}
                    // loading={loading}
                    // cssOverride={override}
                    size={50}
                    aria-label='Searching'
                    data-testid='loader'
                  />
                </div>
              )}
              {fans !== null && fans.length <= 0 && loading === false && (
                <div
                  style={{ width: '100%', marginTop: 50, textAlign: 'center' }}
                >
                  Không có kết quả phù hợp
                </div>
              )}
              {fans !== null && fans.length > 0 && (
                <table class='min-w-full divide-y divide-gray-200 dark:divide-gray-700'>
                  <thead>
                    <tr
                      class='divide-x divide-gray-200 dark:divide-gray-700'
                      style={{ background: '#7d8ec1' }}
                    >
                      <th
                        scope='col'
                        class='px-6 py-3 text-start text-xs font-medium text-gray-500 uppercase'
                      >
                        Model
                      </th>
                      <th
                        scope='col'
                        class='px-6 py-3 text-start text-xs font-medium text-gray-500 uppercase'
                      >
                        Volume
                      </th>
                      <th
                        scope='col'
                        class='px-6 py-3 text-start text-xs font-medium text-gray-500 uppercase'
                      >
                        T.P
                      </th>
                      <th
                        scope='col'
                        class='px-6 py-3 text-end text-xs font-medium text-gray-500 uppercase'
                      >
                        S.P
                      </th>
                      <th
                        scope='col'
                        class='px-6 py-3 text-end text-xs font-medium text-gray-500 uppercase'
                      >
                        RPM
                      </th>
                      <th
                        scope='col'
                        class='px-6 py-3 text-end text-xs font-medium text-gray-500 uppercase'
                      >
                        D.Eff
                      </th>
                      <th
                        scope='col'
                        class='px-6 py-3 text-end text-xs font-medium text-gray-500 uppercase'
                      >
                        Noise
                      </th>
                      <th
                        scope='col'
                        class='px-6 py-3 text-end text-xs font-medium text-gray-500 uppercase'
                      >
                        Velocity
                      </th>
                      <th
                        scope='col'
                        class='px-6 py-3 text-end text-xs font-medium text-gray-500 uppercase'
                      >
                        S.Power
                      </th>
                      <th
                        scope='col'
                        class='px-6 py-3 text-end text-xs font-medium text-gray-500 uppercase'
                      >
                        Rec.Pow
                      </th>
                    </tr>
                  </thead>
                  <tbody class='divide-y divide-gray-200 dark:divide-gray-700'>
                    <tr style={{ background: '#b3bcdb' }}>
                      <td class='px-6 py-1 whitespace-nowrap text-sm font-medium text-gray-800 dark:text-gray-200'></td>
                      <td class='px-6 py-1 whitespace-nowrap text-sm text-gray-800 dark:text-gray-200'>
                        {form.volumeType == 1 ? 'm3/h' : 'l/s'}
                      </td>
                      <td class='px-6 py-1 whitespace-nowrap text-sm text-gray-800 dark:text-gray-200'>
                        Pa
                      </td>
                      <td class='px-6 py-1 whitespace-nowrap text-end text-sm font-medium'>
                        Pa
                      </td>
                      <td class='px-6 py-1 whitespace-nowrap text-end text-sm font-medium'>
                        r/min
                      </td>
                      <td class='px-6 py-1 whitespace-nowrap text-end text-sm font-medium'>
                        %
                      </td>
                      <td class='px-6 py-1 whitespace-nowrap text-end text-sm font-medium'>
                        dB(A)
                      </td>
                      <td class='px-6 py-1 whitespace-nowrap text-end text-sm font-medium'>
                        m/s
                      </td>
                      <td class='px-6 py-1 whitespace-nowrap text-end text-sm font-medium'>
                        kW
                      </td>
                      <td class='px-6 py-1 whitespace-nowrap text-end text-sm font-medium'>
                        kW
                      </td>
                    </tr>
                    {fans.map((fan) => (
                      <tr
                        className='modelFanRow'
                        onDoubleClick={() => handleSelect(fan)}
                        style={{ cursor: 'pointer' }}
                      >
                        <td class='px-6 py-1 whitespace-nowrap text-sm font-medium text-gray-800 dark:text-gray-200'>
                          {getModelName(fan, modelTypeSelect)}
                        </td>
                        <td class='px-6 py-1 whitespace-nowrap text-sm text-gray-800 dark:text-gray-200'>
                          {getVolume(fan, form)}
                        </td>
                        <td class='px-6 py-1 whitespace-nowrap text-sm text-gray-800 dark:text-gray-200'>
                          {fan.fan_total_pressure}
                        </td>
                        <td class='px-6 py-1 whitespace-nowrap text-end text-sm font-medium'>
                          {fan.fan_static_pressure}
                        </td>
                        <td class='px-6 py-1 whitespace-nowrap text-end text-sm font-medium'>
                          {fan.fan_speed / 100}
                        </td>
                        <td class='px-6 py-1 whitespace-nowrap text-end text-sm font-medium'>
                          {fan.fan_total_efficiency.toFixed(2) / 100}
                        </td>
                        <td class='px-6 py-1 whitespace-nowrap text-end text-sm font-medium'>
                          {getNoise(fan, form)}
                        </td>
                        <td class='px-6 py-1 whitespace-nowrap text-end text-sm font-medium'>
                          {fan.fan_outlet_velocity.toFixed(2) / 100}
                        </td>
                        <td class='px-6 py-1 whitespace-nowrap text-end text-sm font-medium'>
                          {fan.fan_shaft_power.toFixed(2) / 100}
                        </td>
                        <td class='px-6 py-1 whitespace-nowrap text-end text-sm font-medium'>
                          {fan.motor_power_origin}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        )}
        {tab == 2 && (
          <div class='py-1'>
            <div style={{ marginTop: 25 }}>
              <button type='button' class='btn-custom py-2' onClick={handlePDF}>
                Xuất PDF
              </button>
            </div>
            <Exporter
              selecteds={selectedFan}
              handleDeselect={handleDeselect}
              handlePreview={handlePreview}
            />
          </div>
        )}
      </div>
    </>
  );
};
export default Reporter;
